module.exports = __webpack_public_path__ + "static/media/DSC_0168.a27d9c07.jpg";